import {
  Button,
  Select,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Portal,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Progress,
  Box,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";
import {
  MdOutlineRefresh,
  MdArrowBack,
  MdEdit,
  MdDeleteOutline,
  MdOutlineVisibility,
  MdMoreVert,
} from "react-icons/md";
import Loading from "../ui/Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  closeAddCustomersDrawer,
  closeEditCustomersDrawer,
  closeShowDetailsCustomersDrawer,
  openAddCustomersDrawer,
  openEditCustomersDrawer,
  openShowDetailsCustomersDrawer,
} from "../../redux/reducers/misc";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import { FcDatabase } from "react-icons/fc";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import moment from "moment";

import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { usePagination, useSortBy, useTable } from "react-table";
import ClickMenu from "../ui/ClickMenu";
import CustomersEditDrawer from "../ui/Drawers/Edit Drawers/CustomersEditDrawer";
import CustomersDetailsDrawer from "../ui/Drawers/Details Drawers/CustomersDetailsDrawer";
import CustomersDrawer from "../ui/Drawers/Add Drawers/CustomersDrawer";

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from "@chakra-ui/react";
import { checkAccess } from "../../utils/checkAccess";
import { Link } from "react-router-dom";
import { BiTable, BiCard } from "react-icons/bi";

const columns = [
  {
    Header: "ID",
    accessor: "uniqueId",
  },
  {
    Header: "Total Price",
    accessor: "totalInvoiceAmount",
    Cell: ({ value }) =>
      typeof value === "number"
        ? value.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
          minimumFractionDigits: 2,
        })
        : "₹0.00",
  },
  {
    Header: "Type",
    accessor: "customertype",
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Products",
    accessor: (row) =>
      row?.products && row.products.length > 0
        ? row.products
          .map((product) => product?.name)
          .filter(Boolean)
          .join(", ")
        : "Not Available",
    id: "products",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Sale Date",
    accessor: "saleDate",
    Cell: ({ value }) => (value ? moment(value).format("DD/MM/YYYY") : "N/A"),
    id: "sale_date",
  },
  {
    Header: "Delivery Date",
    accessor: "deliveryDate",
    Cell: ({ value }) => (value ? moment(value).format("DD/MM/YYYY") : "N/A"),
    id: "delivery_date",
  },
  {
    Header: "Payment Received",
    accessor: "lastPaymentAmount",
    id: "payment_received",
  },
  // {
  //   Header: "RI File",
  //   accessor: "riFile",
  // },
];

const Customer = () => {
  const [cookies] = useCookies();
  const [data, setData] = useState([{}, {}]);
  const [filteredData, setFilteredData] = useState([]);
  const [dataId, setDataId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedCustomerForPayment, setSelectedCustomerForPayment] = useState(null);
  const dispatch = useDispatch();
  const [viewMode, setViewMode] = useState("table");

  const {
    isOpen: isPaymentOpen,
    onOpen: onPaymentOpen,
    onClose: onPaymentClose,
  } = useDisclosure();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    state: { pageIndex, pageSize },
    pageCount,
    setPageSize,
  } = useTable(
    {
      columns,
      data: filteredData,
      initialState: { pageSize: 5 },
    },
    useSortBy,
    usePagination
  );

  const {
    addCustomersDrawerIsOpened,
    editCustomersDrawerIsOpened,
    showDetailsCustomersDrawerIsOpened,
  } = useSelector((state) => state.misc);

  const { role, ...auth } = useSelector((state) => state.auth);
  const { isAllowed, msg } = checkAccess(auth, "customer");

  const [customerDeleteId, setCustomerDeleteId] = useState();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();

  const statusStyles = {
    "deal done": {
      bg: "rgb(65, 105, 225)",
      text: "#fff",
    },
    "proforma invoice sent": {
      bg: "rgb(135, 206, 235)",
      text: "#fff",
    },
    "invoice sent": {
      bg: "rgb(255, 127, 80)",
      text: "#fff",
    },
    "payment received": {
      bg: "rgb(0, 100, 0)",
      text: "#fff",
    },
  };

  const baseURL = process.env.REACT_APP_BACKEND_URL;

  const fetchAllCustomers = async () => {
    setSearchKey("");
    setLoading(true);
    setData([]);
    setFilteredData([]);
    setLoading(true);
    try {
      const response = await fetch(baseURL + "customer/all-customers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      setData(data.customers);
      setFilteredData(data.customers);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  console.log(data);

  const addCustomersHandler = () => {
    dispatch(openAddCustomersDrawer());
  };

  const editHandler = (id) => {
    setDataId(id);
    dispatch(openEditCustomersDrawer());
  };

  const showDetailsHandler = (id) => {
    setDataId(id);
    dispatch(openShowDetailsCustomersDrawer());
  };

  const confirmDeleteHandler = async () => {
    onOpen();
  };

  const deleteHandler = async () => {
    if (!customerDeleteId) {
      return;
    }

    try {
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(baseURL + "customer/delete-customer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies?.access_token}`,
        },
        body: JSON.stringify({
          customerId: customerDeleteId,
        }),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message);
      }

      toast.success(data.message);
      fetchAllCustomers();
      onClose();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const downloadRIFile = async (customerId, customerName) => {
    try {
      const customer = data.find((c) => c._id === customerId);
      if (!customer || !customer.riFile) {
        toast.error("No RI file found for this customer");
        return;
      }

      if (customer.riFile.startsWith("http")) {
        window.open(customer.riFile, "_blank");
        toast.success("RI file opened in new tab");
      } else {
        const link = document.createElement("a");
        link.href = customer.riFile;
        link.download = `RI_${customerName?.replace(
          /\s+/g,
          "_"
        )}_${customerId}`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("RI file download started");
      }
    } catch (error) {
      console.error("Error downloading RI file:", error);
      toast.error("Failed to download RI file");
    }
  };

  useEffect(() => {
    if (isAllowed) {
      fetchAllCustomers();
    }
  }, []);

  useEffect(() => {
    if (searchKey.trim() !== "") {
      const searchedData = data.filter(
        (d) =>
          d?._id?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.name?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.creator?.toLowerCase().includes(searchKey.toLowerCase()) ||
          (d?.createdAt &&
            new Date(d?.createdAt)
              ?.toISOString()
              ?.substring(0, 10)
              ?.split("-")
              .reverse()
              .join("")
              ?.includes(searchKey.replaceAll("/", ""))) ||
          (d?.customertype === "People"
            ? "individual".includes(searchKey.toLowerCase())
            : "corporate".includes(searchKey.toLowerCase())) ||
          d?.status?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.phone?.includes(searchKey) ||
          d?.email?.toLowerCase().includes(searchKey.toLowerCase())
      );
      setFilteredData(searchedData);
    } else {
      setFilteredData(data);
    }
  }, [searchKey]);

  return (
    <>
      {!isAllowed && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-3xl font-bold text-[#ff6f6f] flex gap-x-2">
          {msg}
          {auth?.isTrial && !auth?.isTrialEnded && (
            <div className="-mt-1">
              <Link to="/pricing">
                <button className="text-base border border-[#d61616] rounded-md px-5 py-1 bg-[#d61616] text-white font-medium hover:bg-white hover:text-[#d61616] ease-in-out duration-300">
                  {auth?.account?.trial_started || auth?.isSubscriptionEnded
                    ? "Upgrade"
                    : "Activate Free Trial"}
                </button>
              </Link>
            </div>
          )}
        </div>
      )}

      {isAllowed && (
        <div
          className="border-[1px] px-2 py-8 md:px-9 rounded"
          style={{ boxShadow: "0 0 20px 3px #96beee26" }}
        >
          <>
            <AlertDialog
              isOpen={isOpen}
              leastDestructiveRef={cancelRef}
              onClose={onClose}
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    Delete Customer
                  </AlertDialogHeader>

                  <AlertDialogBody>
                    Are you sure, deleting a Customer will also delete its
                    corresponding Invoices, Proforma Invoices, Leads, Offers?
                  </AlertDialogBody>

                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                      Cancel
                    </Button>
                    <Button colorScheme="red" onClick={deleteHandler} ml={3}>
                      Delete
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>

            {/* Payment details modal: toggles between invoice/payment info and percentage view */}
            <Modal isOpen={isPaymentOpen} onClose={() => { setSelectedCustomerForPayment(null); onPaymentClose(); }} size="lg">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Payment Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Tabs>
                    <TabList>
                      <Tab>Invoices / Payments</Tab>
                      <Tab>Percentage</Tab>
                    </TabList>

                    <TabPanels>
                      <TabPanel>
                        {selectedCustomerForPayment ? (
                          <VStack align="stretch" spacing={3}>
                            <HStack justify="space-between">
                              <Text fontWeight={600}>Customer</Text>
                              <Text>{selectedCustomerForPayment.name}</Text>
                            </HStack>
                            <HStack justify="space-between">
                              <Text fontWeight={600}>Total Invoice Amount</Text>
                              <Text>
                                {typeof selectedCustomerForPayment.totalInvoiceAmount === 'number'
                                  ? selectedCustomerForPayment.totalInvoiceAmount.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 })
                                  : '₹0.00'}
                              </Text>
                            </HStack>
                            <HStack justify="space-between">
                              <Text fontWeight={600}>Last Payment Amount</Text>
                              <Text>
                                {typeof selectedCustomerForPayment.lastPaymentAmount === 'number'
                                  ? selectedCustomerForPayment.lastPaymentAmount.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 })
                                  : '₹0.00'}
                              </Text>
                            </HStack>
                            <HStack justify="space-between">
                              <Text fontWeight={600}>Sale Date</Text>
                              <Text>
                                {selectedCustomerForPayment.saleDate
                                  ? moment(selectedCustomerForPayment.saleDate).format('DD/MM/YYYY')
                                  : 'N/A'}
                              </Text>
                            </HStack>
                            <HStack justify="space-between">
                              <Text fontWeight={600}>Delivery Date</Text>
                              <Text>
                                {selectedCustomerForPayment.deliveryDate
                                  ? moment(selectedCustomerForPayment.deliveryDate).format('DD/MM/YYYY')
                                  : 'N/A'}
                              </Text>
                            </HStack>

                            {/* If there's a payments or invoices array, show it; otherwise simple message */}
                            {Array.isArray(selectedCustomerForPayment.invoices) && selectedCustomerForPayment.invoices.length > 0 ? (
                              <Box>
                                {selectedCustomerForPayment.invoices.map((inv, idx) => (
                                  <Box key={idx} borderWidth={1} borderRadius="md" p={2} mb={2}>
                                    <HStack justify="space-between">
                                      <Text fontSize="sm">{inv?.invoiceNo || `Invoice ${idx + 1}`}</Text>
                                      <Text fontSize="sm">{typeof inv?.amount === 'number' ? inv.amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 }) : '₹0.00'}</Text>
                                    </HStack>
                                  </Box>
                                ))}
                              </Box>
                            ) : (
                              <Text fontSize="sm" color="gray.600">No detailed invoices available.</Text>
                            )}
                          </VStack>
                        ) : (
                          <Text>No customer selected.</Text>
                        )}
                      </TabPanel>

                      <TabPanel>
                        {selectedCustomerForPayment ? (
                          <VStack align="stretch" spacing={4}>
                            <Text>
                              Percentage of amount received against total invoice amount.
                            </Text>
                            {typeof selectedCustomerForPayment.totalInvoiceAmount === 'number' && selectedCustomerForPayment.totalInvoiceAmount > 0 ? (
                              (() => {
                                const total = selectedCustomerForPayment.totalInvoiceAmount || 0;
                                const paid = selectedCustomerForPayment.lastPaymentAmount || 0;
                                const pct = Math.min(100, Math.round((paid / total) * 10000) / 100) || 0;
                                return (
                                  <Box>
                                    <Text fontSize="lg" fontWeight={700}>{pct}%</Text>
                                    <Progress value={pct} size="md" colorScheme={pct >= 100 ? 'green' : 'blue'} mt={2} />
                                    <HStack justify="space-between" mt={3}>
                                      <Text fontSize="sm">Received</Text>
                                      <Text fontSize="sm">{typeof paid === 'number' ? paid.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 }) : '₹0.00'}</Text>
                                    </HStack>
                                    <HStack justify="space-between">
                                      <Text fontSize="sm">Total</Text>
                                      <Text fontSize="sm">{total.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 })}</Text>
                                    </HStack>
                                  </Box>
                                );
                              })()
                            ) : (
                              <Text>No invoice amount available to calculate percentage.</Text>
                            )}
                          </VStack>
                        ) : (
                          <Text>No customer selected.</Text>
                        )}
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                </ModalBody>

                <ModalFooter>
                  <Button onClick={() => { setSelectedCustomerForPayment(null); onPaymentClose(); }}>Close</Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
          <div>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-8 bg-white/70 backdrop-blur-sm border border-gray-200 rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.06)] p-3">
              {/* Title */}
              <div className="text-lg md:text-xl font-semibold text-gray-800">
                Customer List
              </div>

              {/* Controls */}
              <div className="flex flex-col sm:flex-row flex-wrap w-full md:w-auto gap-2">
                <textarea
                  className="rounded-lg border border-gray-300 w-full sm:w-auto px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1640d6] transition-all resize-none"
                  rows="1"
                  placeholder="Search"
                  value={searchKey}
                  onChange={(e) => setSearchKey(e.target.value)}
                />

                <Button
                  fontSize={{ base: "14px", md: "14px" }}
                  px={{ base: "10px", md: "12px" }}
                  py={{ base: "2px", md: "3px" }}
                  width={{ base: "full", sm: "auto" }}
                  onClick={fetchAllCustomers}
                  leftIcon={<MdOutlineRefresh />}
                  color="#1640d6"
                  borderColor="#1640d6"
                  variant="outline"
                >
                  Refresh
                </Button>

                <Select
                  onChange={(e) => setPageSize(e.target.value)}
                  width={{ base: "full", sm: "80px" }}
                  className="text-sm"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={100000}>All</option>
                </Select>

                {/* <Button
                  onClick={addCustomersHandler}
                  color="white"
                  backgroundColor="#1640d6"
                  width={{ base: "full", sm: "auto" }}
                  _hover={{ backgroundColor: "#1035ad" }}
                >
                  Add New Customer
                </Button> */}
              </div>
            </div>


            <div>
              {addCustomersDrawerIsOpened && (
                <ClickMenu
                  top={0}
                  right={0}
                  closeContextMenuHandler={() =>
                    dispatch(closeAddCustomersDrawer())
                  }
                >
                  <CustomersDrawer
                    closeDrawerHandler={() =>
                      dispatch(closeAddCustomersDrawer())
                    }
                    fetchAllCustomers={fetchAllCustomers}
                  />
                </ClickMenu>
              )}

              {editCustomersDrawerIsOpened && (
                <ClickMenu
                  top={0}
                  right={0}
                  closeContextMenuHandler={() =>
                    dispatch(closeEditCustomersDrawer())
                  }
                >
                  <CustomersEditDrawer
                    dataId={dataId}
                    closeDrawerHandler={() =>
                      dispatch(closeEditCustomersDrawer())
                    }
                    fetchAllCustomers={fetchAllCustomers}
                  />
                </ClickMenu>
              )}

              {showDetailsCustomersDrawerIsOpened && (
                <ClickMenu
                  top={0}
                  right={0}
                  closeContextMenuHandler={() =>
                    dispatch(closeShowDetailsCustomersDrawer())
                  }
                >
                  <CustomersDetailsDrawer
                    dataId={dataId}
                    closeDrawerHandler={() =>
                      dispatch(closeShowDetailsCustomersDrawer())
                    }
                  />
                </ClickMenu>
              )}
              {loading && (
                <div>
                  <Loading />
                </div>
              )}
              {!loading && filteredData.length === 0 && (
                <div className="flex items-center justify-center flex-col">
                  <FcDatabase color="red" size={80} />
                  <span className="mt-1 font-semibold text-2xl">
                    No data found.
                  </span>
                </div>
              )}

              {/* Card/Table Toggle */}
              {!loading && filteredData.length > 0 && (
                <div className="flex justify-end mb-4 gap-2">
                  <button
                    onClick={() => setViewMode("table")}
                    className={`flex items-center gap-1 px-3 py-1 rounded-md border transition
      ${viewMode === "table"
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-white text-blue-600 border-blue-600"}
    `}
                  >
                    <BiTable size={18} />

                  </button>

                  <button
                    onClick={() => setViewMode("card")}
                    className={`flex items-center gap-1 px-3 py-1 rounded-md border transition
      ${viewMode === "card"
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-white text-blue-600 border-blue-600"}
    `}
                  >
                    <BiCard size={18} />

                  </button>
                </div>
              )}

              {/* CARD VIEW */}
              {viewMode === "card" && (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">

                  {filteredData.map((cust) => (
                    <div
                      key={cust._id}
                      className="border rounded-lg p-4 bg-white shadow-md hover:shadow-lg transition-shadow duration-300"
                    >
                      {/* TOP BADGES */}
                      <div className="flex justify-between items-center mb-3">
                        {/* UNIQUE ID */}
                        <div className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-md text-sm font-semibold">
                          {cust.uniqueId || "N/A"}
                        </div>

                        {/* Customer Type Badge */}
                        <div
                          className={`px-3 py-1 rounded-md text-sm font-semibold ${cust.customertype === "People"
                              ? "bg-pink-100 text-pink-600"
                              : "bg-blue-100 text-blue-600"
                            }`}
                        >
                          {cust.customertype === "People" ? "Individual" : "Corporate"}
                        </div>
                      </div>

                      {/* NAME */}
                      <p className="font-semibold text-lg text-gray-900">{cust.name}</p>

                      {/* CUSTOMER INFO */}
                      <div className="mt-3 space-y-1 text-sm text-gray-700">
                        <p>
                          <strong>Email:</strong> {cust.email || "N/A"}
                        </p>
                        <p>
                          <strong>Phone:</strong> {cust.phone || "N/A"}
                        </p>
                        <p>
                          <strong>Total Price:</strong>{" "}
                          {typeof cust.totalInvoiceAmount === "number"
                            ? cust.totalInvoiceAmount.toLocaleString("en-IN", {
                              style: "currency",
                              currency: "INR",
                              minimumFractionDigits: 2,
                            })
                            : "₹0.00"}
                        </p>
                        <p>
                          <strong>Products:</strong>{" "}
                          {Array.isArray(cust.products) && cust.products.length > 0
                            ? cust.products.map((p) => p.name).join(", ")
                            : "Not Available"}
                        </p>
                        <p>
                          <strong>Payment:</strong>{" "}
                          {cust.lastPaymentAmount || 0}
                        </p>
                      </div>

                      {/* ACTION BUTTONS */}
                      <div className="flex justify-center gap-3 pt-3 border-t border-gray-200">
                        <Button
                          size="sm"
                          variant="outline"
                          colorScheme="blue"
                          onClick={() => showDetailsHandler(user._id)}
                          leftIcon={<MdOutlineVisibility />}
                        >
                          View
                        </Button>

                        <Button
                          size="sm"
                          variant="outline"
                          colorScheme="orange"
                          onClick={() => editHandler(user._id)}
                          leftIcon={<MdEdit />}
                        >
                          Edit
                        </Button>

                        <Button
                          size="sm"
                          variant="outline"
                          colorScheme="red"
                          onClick={() => {
                            onOpen();
                            setDeleteEmployeeSelectedId(user._id);
                          }}
                          leftIcon={<MdDeleteOutline />}
                        >
                          Delete
                        </Button>
                      </div>

                    </div>
                  ))}

                </div>
              )}



              {!loading && filteredData.length > 0 && (
                <div>
                  {viewMode === "table" && (
                    <TableContainer
                      maxHeight="600px"
                      overflowY="auto"
                      shadow="md"
                      borderRadius="lg"
                      border="1px solid"
                      borderColor="gray.200"
                    >
                      <Table variant="striped" {...getTableProps()}>
                        <Thead className="bg-blue-400 text-white text-lg font-semibold sticky top-0 z-10">
                          {headerGroups.map((hg) => {
                            return (
                              <Tr
                                {...hg.getHeaderGroupProps()}
                                className="border-b-2 border-gray-300"
                              >
                                {hg.headers.map((column) => {
                                  return (
                                    <Th
                                      className={`
                    ${column.id === "name"
                                          ? "sticky top-0 left-[-2px]"
                                          : "sticky top-0"
                                        }
                    text-transform: capitalize
                    font-size: 15px
                    font-weight: 700
                    text-center
                    border-r border-gray-300
                    py-3
                    px-4
                    hover:bg-blue-200 cursor-pointer
                    bg-blue-400
                    z-10
                  `}
                                      {...column.getHeaderProps(
                                        column.getSortByToggleProps()
                                      )}
                                    >
                                      <div className="flex items-center justify-center text-white ">
                                        {column.render("Header")}
                                        {column.isSorted && (
                                          <span className="ml-1 text-xs">
                                            {column.isSortedDesc ? (
                                              <FaCaretDown />
                                            ) : (
                                              <FaCaretUp />
                                            )}
                                          </span>
                                        )}
                                      </div>
                                    </Th>
                                  );
                                })}
                                <Th className="text-center py-3 px-4 bg-blue-400 text-white sticky top-0 z-10">
                                  <p className="text-white">Actions</p>
                                </Th>
                              </Tr>
                            );
                          })}
                        </Thead>

                        <Tbody {...getTableBodyProps()}>
                          {page.map((row) => {
                            prepareRow(row);

                            return (
                              <Tr
                                className="relative hover:bg-gray-100 text-base text-gray-700 transition duration-300 ease-in-out"
                                {...row.getRowProps()}
                              >
                                {row.cells.map((cell) => {
                                  return (
                                    <Td
                                      className={` ${cell.column.id === "name"
                                        ? "sticky top-0 left-[-2px] bg-[#f9fafc]"
                                        : ""
                                        } text-center border-b border-gray-200 p-3 `}
                                      {...cell.getCellProps()}
                                    >
                                      {cell.column.id !== "customertype" &&
                                        cell.column.id !== "status" &&
                                        cell.column.id !== "created_on" &&
                                        cell.column.id !== "riFile" &&
                                        cell.column.id !== "payment_received" &&
                                        cell.render("Cell")}
                                      {cell.column.id === "customertype" && (
                                        <span
                                          className={`text-sm rounded-md px-3 py-1 ${cell.row.original.customertype ===
                                            "People"
                                            ? "bg-[#fff0f6] text-[#c41d7f]"
                                            : "bg-[#e6f4ff] text-[#0958d9]"
                                            }`}
                                        >
                                          {cell.row.original.customertype ===
                                            "People"
                                            ? "Individual"
                                            : "Corporate"}
                                        </span>
                                      )}
                                      {cell.column.id === "created_on" &&
                                        row.original?.createdAt && (
                                          <span>
                                            {moment(
                                              row.original?.createdAt
                                            ).format("DD/MM/YYYY")}
                                          </span>
                                        )}
                                      {cell.column.id === "status" && (
                                        <span
                                          className="text-sm rounded-md px-3 py-1"
                                          style={{
                                            backgroundColor: `${statusStyles[
                                              row.original.status?.toLowerCase()
                                            ]?.bg
                                              }`,
                                            color: `${statusStyles[
                                              row.original.status?.toLowerCase()
                                            ]?.text
                                              }`,
                                          }}
                                        >
                                          {row.original.status}
                                        </span>
                                      )}
                                      {cell.column.id === "payment_received" && (
                                        <div className="flex items-center justify-center">
                                          <Button
                                            size="sm"
                                            variant="outline"
                                            onClick={() => {
                                              setSelectedCustomerForPayment(row.original);
                                              onPaymentOpen();
                                            }}
                                          >
                                            Details
                                          </Button>
                                        </div>
                                      )}
                                      {cell.column.id === "riFile" && (
                                        <div className="flex justify-center">
                                          {row.original.riFile ? (
                                            <Button
                                              size="sm"
                                              colorScheme="blue"
                                              variant="outline"
                                              onClick={() =>
                                                downloadRIFile(
                                                  row.original._id,
                                                  row.original.name
                                                )
                                              }
                                              className="text-xs"
                                            >
                                              Download RI
                                            </Button>
                                          ) : (
                                            <span className="text-gray-400 text-sm">
                                              No RI File
                                            </span>
                                          )}
                                        </div>
                                      )}
                                    </Td>
                                  );
                                })}

                                <Td className="text-center p-3">
                                  <Menu>
                                    <MenuButton
                                      as={IconButton}
                                      aria-label="Options"
                                      icon={<MdMoreVert />}
                                      variant="ghost"
                                      size="sm"
                                      onClick={() =>
                                        setSelectedRowId(row.original?._id)
                                      }
                                    />
                                    <Portal>
                                      <MenuList>
                                        <MenuItem
                                          icon={<MdOutlineVisibility />}
                                          onClick={() =>
                                            showDetailsHandler(row.original?._id)
                                          }
                                        >
                                          View
                                        </MenuItem>
                                        <MenuItem
                                          icon={<MdEdit />}
                                          onClick={() =>
                                            editHandler(row.original?._id)
                                          }
                                        >
                                          Edit
                                        </MenuItem>
                                        <MenuItem
                                          icon={<MdDeleteOutline />}
                                          onClick={() => {
                                            setCustomerDeleteId(row.original?._id);
                                            confirmDeleteHandler();
                                          }}
                                        >
                                          Delete
                                        </MenuItem>
                                      </MenuList>
                                    </Portal>
                                  </Menu>
                                </Td>
                              </Tr>
                            );
                          })}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  )}

                  <div className="w-[max-content] m-auto my-7">
                    <button
                      className="text-sm mt-2 bg-[#1640d6] py-1 px-4 text-white border-[1px] border-[#1640d6] rounded-3xl disabled:bg-[#b2b2b2] disabled:border-[#b2b2b2] disabled:cursor-not-allowed md:text-lg md:py-1 md:px-4 lg:text-xl lg:py-1 xl:text-base"
                      disabled={!canPreviousPage}
                      onClick={previousPage}
                    >
                      Prev
                    </button>
                    <span className="mx-3 text-sm md:text-lg lg:text-xl xl:text-base">
                      {pageIndex + 1} of {pageCount}
                    </span>
                    <button
                      className="text-sm mt-2 bg-[#1640d6] py-1 px-4 text-white border-[1px] border-[#1640d6] rounded-3xl disabled:bg-[#b2b2b2] disabled:border-[#b2b2b2] disabled:cursor-not-allowed md:text-lg md:py-1 md:px-4 lg:text-xl lg:py-1 xl:text-base"
                      disabled={!canNextPage}
                      onClick={nextPage}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}




            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Customer;